import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { ArrowRight, Shield, Truck, Users, Settings, Phone } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const About: React.FC = () => {
  const { t } = useLanguage();
  
  const whyChooseUs = [
    { textKey: 'aboutWhy1', icon: <Shield className="h-8 w-8" /> },
    { textKey: 'aboutWhy2', icon: <Truck className="h-8 w-8" /> },
    { textKey: 'aboutWhy3', icon: <Users className="h-8 w-8" /> },
    { textKey: 'aboutWhy4', icon: <Settings className="h-8 w-8" /> },
    { textKey: 'aboutWhy5', icon: <Phone className="h-8 w-8" /> },
  ];

  return (
    <section
      id="about"
      className="relative py-20 sm:py-24 bg-gradient-to-br from-gray-900 to-blue-900 text-white overflow-hidden"
    >
      {/* Decorative Blobs */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-400/10 rounded-full blur-3xl opacity-50"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>

      <div className="container relative px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center">
          {/* Text Content Section */}
          <div className="max-w-3xl text-center mb-16">
            <h2 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-white to-yellow-300 mb-4">
              {t('aboutTitle')}
            </h2>
            <p className="text-lg text-blue-200">
              {t('aboutDescription')}
            </p>
          </div>

          {/* Why Choose Us Section */}
          <div className="mt-16 w-full max-w-5xl">
            <h3 className="text-3xl font-bold text-white text-center mb-8">
              {t('aboutWhyTitle')}
            </h3>
            <div className="flex flex-wrap justify-center gap-6">
              {whyChooseUs.map((item, index) => (
                <Card
                  key={index}
                  className="w-full sm:w-[48%] lg:w-[30%] bg-white/10 border-white/20 hover:bg-white/20 hover:border-white/30 transition-all duration-300"
                >
                  <CardContent className="p-5 flex items-center">
                    <div className="text-3xl mr-4 text-yellow-400">
                      {item.icon}
                    </div>
                    <span className="font-medium text-base">{t(item.textKey)}</span>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>

          {/* CTA Button */}
          <div className="mt-16">
            <Button
              asChild
              size="lg"
              className="bg-yellow-400 hover:bg-yellow-300 text-blue-900 text-lg font-bold shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
            >
              <a href="#contact">
                {t('aboutCTA')}
                <ArrowRight className="ml-2 h-5 w-5" />
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
